import { render, staticRenderFns } from "./ComponentRenderer.vue?vue&type=template&id=208be0c2&scoped=true&"
import script from "./ComponentRenderer.vue?vue&type=script&lang=js&"
export * from "./ComponentRenderer.vue?vue&type=script&lang=js&"
import style0 from "./ComponentRenderer.vue?vue&type=style&index=0&id=208be0c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208be0c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VRow,VTextField})
